import Swiper from "swiper";
import {
	Navigation,
	Pagination,
	EffectFade,
	Autoplay,
	Virtual,
	Zoom,
} from "swiper/modules";
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Virtual, Zoom]);

export default class {
	constructor(options) {
		const scopeThis = this;

		this.defaults = {
			$el: null,
			minItems: 2,
			swiperArgs: {
				slidesPerView: "auto",
				grabCursor: true,
				loop: false,
				speed: 250,
				// autoadvance: false,
				simulateTouch: true,
				// pagination: {
				// 	el: ".swiper-pagination",
				// 	clickable: true,
				// },
				pagination: false,
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: true,
				},
				// keyboard: {
				// 	enabled: true,
				// 	onlyInViewport: true,
				// },
				autoopts: {
					currcycle: 0,
					maxcycle: 1000,
				},
			},
		};
		this.options = {};
		this.allowUpdate = true;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPS_Swiper";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			let args = this.options.swiperArgs;
			let elScope = this.$el;
			let scopeThis = this;
			if (!this.$el.id) {
				this.$el.id = `gallery-${Math.floor(Math.random() * 1000000)}`;
			}

			if (
				this.$el.parentElement.classList.contains(
					"section-photo_carousel"
				)
			) {
				args.centeredSlides = false;
				args.slidesPerView = "auto";
				args.loop = false;
				args.spaceBetween = 0;
				args.autoHeight = false;
			}

			if (
				this.$el.parentElement.classList.contains(
					"story__collection--cards"
				)
			) {
				args.centeredSlides = true;
				args.slidesPerView = "auto";
				args.loop = true;
				args.spaceBetween = 0;
				args.autoHeight = false;
				args.freeMode = true;
			}

			if (this.$el.parentElement.classList.contains("autocycle")) {
				args.centeredSlides = true;
				args.slidesPerView = 1;
				args.minItems = 1;
				args.loop = true;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.autoHeight = false;
				// set crossfade speed to 250 milliseconds
				args.autoplay = {
					delay: 1200,
					disableOnInteraction: false,
				};
			}

			if (
				this.$el.parentElement.classList.contains(
					"gallery__modal--dynamic"
				) ||
				this.$el.parentElement.classList.contains(
					"gallery__modal--dynamic-drawings"
				)
			) {
				args.centeredSlides = true;
				args.slidesPerView = 1;
				args.minItems = 0;
				args.loop = false;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.zoom = true;
				args.fadeEffect = {
					crossFade: true,
				};
				args.autoHeight = false;
				args.pagination = {
					el: ".swiper-pagination",
					type: "fraction",
				};
				args.simulateTouch = true;
				// args.keyboard = {
				// 	enabled: true,
				// 	onlyInViewport: false,
				// 	pageUpDown: true,
				// };

				args.virtual = {
					addSlidesAfter: 0,
					addSlidesBefore: 0,
					slides: (function () {
						const slides = [];
						return slides;
					})(),
					// renderExternal: function (data) {
					// 	return data;
					// },
				};
			}

			if (
				this.$el.parentElement.classList.contains("section-gallery") &&
				!this.$el.parentElement.classList.contains("autocycle")
			) {
				args.centeredSlides = true;
				args.slidesPerView = 1;
				args.minItems = 1;
				args.loop = true;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.autoHeight = false;
				args.simulateTouch = false;
				args.allowTouchMove = false;

				args.pagination = {
					el: ".swiper-pagination",
					clickable: true,
				};
			}

			if (this.$el.parentElement.classList.contains("hero-media")) {
				args.centeredSlides = true;
				args.slidesPerView = 1;
				args.minItems = 1;
				args.loop = true;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.autoHeight = false;
				args.zoom = true;
				// enable keyboard nav
				// args.keyboard = {
				// 	enabled: true,
				// 	onlyInViewport: true,
				// 	pageUpDown: false,
				// };
				// args.autoplay = {
				// 	delay: 4000,
				// 	disableOnInteraction: true,
				// };
			}
			if (this.$el.parentElement.classList.contains("hero-media--home")) {
				args.centeredSlides = false;
				args.slidesPerView = 1;
				args.minItems = 1;
				args.loop = true;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.autoHeight = false;
				args.simulateTouch = false;
				args.virtualTranslate = true;
				// args.fadeEffect = {
				// 	crossFade: false,
				// };
				args.autoplay = {
					delay: 6000,
					disableOnInteraction: false,
				};
			}

			if (
				this.$el.parentElement.classList.contains("section-recognition")
			) {
				args.centeredSlides = true;
				args.slidesPerView = 1;
				args.minItems = 1;
				args.loop = false;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.simulateTouch = false;
				// args.autoHeight = false;
				args.pagination = {
					el: ".swiper-pagination",
					clickable: false,
					type: "fraction",
				};
			}

			if (
				this.$el.parentElement.classList.contains(
					"people__media--gallery"
				)
			) {
				args.slidesPerView = 1;
				args.minItems = 1;
				args.loop = true;
				args.spaceBetween = 0;
				args.effect = "fade";
				args.pagination = {
					el: ".swiper-pagination",
					clickable: true,
				};
				args.autoplay = {
					delay: 4000,
					disableOnInteraction: true,
				};
			}

			if (
				this.$el.parentElement.classList.contains("whoweare-galleryin")
			) {
				args.slidesPerView = 1.3;
				args.minItems = 1;
				args.loop = false;
				args.spaceBetween = 0;
				args.centeredSlides = true;
				// clone extra slides to the end of the gallery
				args.loopedSlides = 3;
			}

			if (this.$el.classList.contains("loop-true")) {
				args.loop = true;
			}
			if (this.$el.classList.contains("start-slide-2")) {
				args.initialSlide = 1;
			}
			if (this.$el.classList.contains("storycollection")) {
				// auto height off
				args.autoHeight = false;
			}

			if (
				this.$el.querySelectorAll(".swiper-slide").length <
					this.options.minItems ||
				this.$el.classList.contains("no-carousel")
			) {
				if (
					!this.$el.parentElement.classList.contains(
						"gallery__modal--dynamic"
					) &&
					!this.$el.parentElement.classList.contains(
						"gallery__modal--dynamic-drawings"
					)
				) {
					this.$el.classList.add("no-carousel");
					return;
				}
			}

			const parentSection = this.$el.closest("section");
			args.navigation = {
				nextEl: parentSection.querySelector(".swiper-nav-button--next"),
				prevEl: parentSection.querySelector(".swiper-nav-button--prev"),
			};

			if (this.$el.classList.contains("auto-advance")) {
				args.autoadvance = true;
			}

			// console.log(args);
			this.swiper = new Swiper(this.$el, args);
			// console.log(this.swiper);

			this.checkSlidesInView();
			window.onresize = () => {
				this.checkSlidesInView();
			};

			if (this.$el.classList.contains("cycle-captions")) {
				if (this.$el.querySelector(".cycle-caption-0")) {
					this.$el
						.querySelector(".cycle-caption-0")
						.classList.add("active");
				}
				this.swiper.on("init slideChange", function () {
					// let activeIndex = this.activeIndex;
					let activeIndex = this.realIndex;
					let $caption = elScope.querySelector(
						".cycle-caption-" + activeIndex
					);
					let $captions = elScope.querySelectorAll(".cycle-caption");
					if ($captions && $captions.length) {
						$captions.forEach((el) => {
							el.classList.remove("active");
						});
					}
					if ($caption) {
						$caption.classList.add("active");
					}
				});
			}

			if (
				this.$el.parentElement.classList.contains("section-gallery") &&
				!this.$el.parentElement.classList.contains("autocycle")
			) {
				// click image will progress to next slide
				const $imgGrid = this.$el.parentElement.querySelectorAll(
					".swiper-zoom-container"
				);
				if ($imgGrid && $imgGrid.length) {
					$imgGrid.forEach((el) => {
						el.addEventListener("click", (e) => {
							this.swiper.slideNext();
						});
					});
				}
			}

			if (
				this.$el.parentElement.classList.contains(
					"gallery__modal--dynamic"
				)
			) {
				// // this.swiper.on("slideChange", () => {
				// // 	scopeThis.swiper.zoom.out(); // Reset zoom when slide changes
				// // });
				// scopeThis.swiper.slides.forEach((slide) => {
				// 	console.log(slide);
				// 	scopeThis.swiper.zoom.initSlide(slide); // Initialize zoom for each slide
				// });
				// this.swiper.on("afterInit", (swiper, slide, index) => {
				// 	scopeThis.swiper.zoom.initSlide(slide);
				// });
			}

			if (
				this.$el.parentElement.classList.contains(
					"gallery__modal--dynamic"
				)
			) {
				const $imgGrid = document.querySelectorAll(
					".img__grid--photographs"
				);
				if ($imgGrid && $imgGrid.length) {
					$imgGrid.forEach((el) => {
						const modalImgs = el.querySelectorAll("a");
						modalImgs.forEach((linkEl) => {
							linkEl.addEventListener("click", (e) => {
								e.preventDefault();

								scopeThis.swiper.virtual.slides = [];
								scopeThis.swiper.virtual.update();

								const $modal = document.querySelector(
									".gallery__modal--dynamic"
								);
								$modal.classList.add("is-active");

								var slides = [];
								modalImgs.forEach((insertEl) => {
									slides.push(
										`<div class="swiper-zoom-container"><img src="${
											insertEl.href
										}" alt="${
											insertEl.querySelector("img")
												?.alt || ""
										}" /></div>`
									);
								});
								scopeThis.swiper.virtual.slides = slides;
								scopeThis.swiper.virtual.update();
								if (scopeThis.swiper.zoom) {
									scopeThis.swiper.zoom.disable();
								}

								// this.swiper.on("slideChange", () => {
								// 	scopeThis.swiper.zoom.out(); // Reset zoom when slide changes
								// });
								// this.swiper.on(
								// 	"afterInit",
								// 	(swiper, slide, index) => {
								// 		scopeThis.swiper.zoom.initSlide(slide);
								// 	}
								// );

								let newIndex =
									Array.from(modalImgs).indexOf(linkEl);
								if (newIndex >= 0) {
									this.swiper.slideTo(newIndex, 0);
								}

								this.swiper.update();
								// console.log(this.swiper.slides);
								if (
									scopeThis.swiper.zoom &&
									scopeThis.swiper.zoom.enabled
								) {
									scopeThis.swiper.zoom.out(); // Reset zoom safely
								}

								// scopeThis.swiper.slides.forEach((slide) => {
								// 	console.log(slide);
								// 	// scopeThis.swiper.zoom.initSlide(slide); // Initialize zoom for each slide
								// });

								this.swiper.on(
									"slideChangeTransitionStart",
									() => {
										if (
											scopeThis.swiper.zoom &&
											scopeThis.swiper.zoom.enabled
										) {
											scopeThis.swiper.zoom.out(); // Reset zoom safely
										}
									}
								);

								setTimeout(function () {
									scopeThis.swiper.zoom.enable();
								}, 1000);
								// this.swiper.zoom.enable();
							});
						});
					});
				}
			}
			if (
				this.$el.parentElement.classList.contains(
					"gallery__modal--dynamic-drawings"
				)
			) {
				const $imgGridDrawings = document.querySelectorAll(
					".img__grid--drawings"
				);
				if ($imgGridDrawings && $imgGridDrawings.length) {
					$imgGridDrawings.forEach((el) => {
						const modalImgsDrawings = el.querySelectorAll("a");
						modalImgsDrawings.forEach((linkElDrawings) => {
							linkElDrawings.addEventListener("click", (e) => {
								e.preventDefault();

								// scopeThis.swiper.virtual.slides = [];
								// scopeThis.swiper.virtual.update();

								const $modal = document.querySelector(
									".gallery__modal--dynamic-drawings"
								);
								$modal.classList.add("is-active");

								var slidesDrawings = [];
								modalImgsDrawings.forEach((insertElDrawing) => {
									slidesDrawings.push(
										`<div class="swiper-zoom-container"><img src="${insertElDrawing.href}" /></div>`
									);
								});
								scopeThis.swiper.virtual.slides =
									slidesDrawings;
								scopeThis.swiper.updateSlides();
								scopeThis.swiper.virtual.update();

								if (scopeThis.swiper.zoom) {
									scopeThis.swiper.zoom.disable();
								}

								let newIndex =
									Array.from(modalImgsDrawings).indexOf(
										linkElDrawings
									);
								if (newIndex >= 0) {
									this.swiper.slideTo(newIndex, 0);
									setTimeout(() => {
										scopeThis.swiper.slideTo(newIndex, 0);
										scopeThis.swiper.update();
									}, 0);
								}

								scopeThis.swiper.updateSlides();
								scopeThis.swiper.update();
								if (
									scopeThis.swiper.zoom &&
									scopeThis.swiper.zoom.enabled
								) {
									scopeThis.swiper.zoom.out(); // Reset zoom safely
								}

								this.swiper.on(
									"slideChangeTransitionStart",
									() => {
										if (
											scopeThis.swiper.zoom &&
											scopeThis.swiper.zoom.enabled
										) {
											scopeThis.swiper.zoom.out(); // Reset zoom safely
										}
									}
								);

								setTimeout(function () {
									scopeThis.swiper.zoom.enable();
								}, 1000);
							});
						});
					});
				}

				// const $modalClose = document.querySelectorAll(
				// 	".gallery__modal--close"
				// );
				// if ($modalClose && $modalClose.length) {
				// 	$modalClose.forEach((el) => {
				// 		el.addEventListener("click", () => {
				// 			scopeThis.swiper.virtual.slides = [];
				// 			scopeThis.swiper.virtual.update();
				// 		});
				// 	});
				// }

				document.addEventListener("keydown", (e) => {
					if (e.key === "ArrowRight") {
						this.swiper.slideNext();
					}
					if (e.key === "ArrowLeft") {
						this.swiper.slidePrev();
					}

					if (e.key === "Escape") {
						const $modal = document.querySelector(
							".gallery__modal--dynamic"
						);
						$modal.classList.remove("is-active");
						const $modalDrawing = document.querySelector(
							".gallery__modal--dynamic-drawings"
						);
						$modalDrawing.classList.remove("is-active");
					}
				});
			}

			if (this.$el.parentElement.classList.contains("hero-media--home")) {
				// when the swiper changes slides, restart the animation on the .hero-media--home:after element
				this.swiper.on("slideChange", () => {
					const heroMediaHome =
						document.querySelector(".hero-media--home");
					heroMediaHome.classList.add("no-ani");
					setTimeout(() => {
						heroMediaHome.classList.remove("no-ani");
					}, 100);
				});
			}

			if (this.$el.classList.contains("explore__carousel")) {
				if (this.$el.querySelector(".tax-project__type")) {
					const taxProjectTypeSlides =
						this.$el.querySelectorAll(".tax-project__type");
					taxProjectTypeSlides.forEach((el) => {
						el.addEventListener("mouseenter", (e) => {
							this.randomizeImg(el);
						});
						el.addEventListener("mouseleave", (e) => {
							this.randomizeImg(el);
						});
					});
				}

				if (this.$el.querySelector(".tax-story__collection")) {
					const taxProjectTypeSlides = this.$el.querySelectorAll(
						".tax-story__collection"
					);
					taxProjectTypeSlides.forEach((el) => {
						el.addEventListener("mouseenter", (e) => {
							this.randomizeCollection(el, true);
						});
						el.addEventListener("mouseleave", (e) => {
							this.randomizeCollection(el, false);
						});
					});
				}

				// if (this.slides) {
				// 	let activeSlide = this.activeIndex;
				// 	let activeSlideClasses = this.slides[activeSlide].classList;
				// 	console.log(activeSlideClasses);
				// }
				this.swiper.on("init slideChange afterInit", function () {
					let activeSlide = this.activeIndex;
					let activeSlideClasses = this.slides[activeSlide].classList;
					// console.log(activeSlideClasses);

					if (activeSlideClasses.contains("tax-project__type")) {
						scopeThis.setExploreType("explore--dynamic-work");
					} else if (
						activeSlideClasses.contains("tax-story__collection")
					) {
						scopeThis.setExploreType(
							"explore--dynamic-collections"
						);
					} else if (activeSlideClasses.contains("type-story")) {
						scopeThis.setExploreType("explore--dynamic-stories");
					}
				});
			}

			// console.log(this.$el.parentElement);
			// this.$el.parentElement.addEventListener("keydown", (e) => {
			// 	console.log(e.key);
			// 	if (e.key === "ArrowRight") {
			// 		this.swiper.slideNext();
			// 	}
			// 	if (e.key === "ArrowLeft") {
			// 		this.swiper.slidePrev();
			// 	}
			// });
		} else {
			this.swiper.destroy(true, true);
		}
	}

	randomizeImg(parEl) {
		const imgs = parEl.querySelectorAll("figure img");
		imgs.forEach((img) => {
			img.classList.remove("is-active");
		});
		const randomImg = imgs[Math.floor(Math.random() * imgs.length)];
		randomImg.classList.add("is-active");
	}

	randomizeCollection(parEl, bool) {
		if (bool) {
			if (parEl.classList.contains("alternate")) {
				parEl.classList.remove("alternate");
			} else {
				parEl.classList.add("alternate");
			}
			const imgs = parEl.querySelectorAll(".rand__stories img");
			const targetEl = parEl.querySelector(".rand__target");
			const imgArr = Array.from(imgs).map((img) => {
				return img.cloneNode(true);
			});

			imgArr.sort(() => Math.random() - 0.5);
			if (imgArr.length > 3) {
				imgArr.splice(3);
			}
			imgArr.forEach((img) => {
				// for each image, generate a random percentage between 0% and 100% for --objtransX variable and same for objtransY variable
				const randomX = Math.floor(Math.random() * 70);
				const randomY = Math.floor(Math.random() * 70);
				img.style.setProperty("--objtransX", randomX - 35 + "%");
				img.style.setProperty("--objtransY", randomY - 35 + "%");
				targetEl.appendChild(img);
			});
		} else {
			// clear the contents of .rand__target
			const targetEl = parEl.querySelector(".rand__target");
			targetEl.innerHTML = "";
		}
		const imgs = parEl.querySelectorAll(".rand__stories img");
		imgs.forEach((img) => {
			if (bool) {
				img.classList.add("is-active");
			} else {
				img.classList.remove("is-active");
			}
		});
	}

	setExploreType(newActive) {
		const exploreHeaders = document.querySelectorAll(
			".home__explore__header"
		);
		exploreHeaders.forEach((el) => {
			const activeEl = el.querySelector(".explore--active");
			if (activeEl) {
				activeEl.classList.remove("explore--active");
			}
			const newActiveEl = el.querySelector(`.${newActive}`);
			if (newActiveEl) {
				newActiveEl.classList.add("explore--active");
			}
		});
	}

	checkSlidesInView() {
		this.slidesReview = this.$el.querySelectorAll(".swiper-slide");
		let allInView = true;
		// console.log(this.slidesReview);
		this.slidesReview.forEach((slide) => {
			let rect = slide.getBoundingClientRect();
			if (rect.left >= 0 && rect.left + rect.width <= window.innerWidth) {
			} else {
				allInView = false;
			}

			let ancestorEl = this.$el.parentElement;
			if (!ancestorEl.querySelector(".swiper-nav-button")) {
				ancestorEl = ancestorEl.parentElement;
			}
			if (ancestorEl.tagName === "BODY") {
				ancestorEl = null;
			}

			if (ancestorEl) {
				if (allInView) {
					ancestorEl.classList.add("all-in-view");
				} else {
					ancestorEl.classList.remove("all-in-view");
					// this.$el.parentElement.parentElement.classList.remove("all-in-view");
				}
			}
		});
	}

	timerTick() {
		// let scopeThis = this;
		// let args = scopeThis.options.swiperArgs;
		// if (!args.autoadvance) {
		// 	// console.log("bailing because autoadvance false");
		// 	return;
		// }
		// args.autoopts.currcycle++;
		// // console.log(args.autoopts.currcycle);
		// if (args.autoopts.currcycle >= args.autoopts.maxcycle) {
		// 	scopeThis.swiper.slideNext();
		// 	args.autoopts.currcycle = 0;
		// }
		// let newFuse = (args.autoopts.currcycle * 1.1) / args.autoopts.maxcycle;
		// if (newFuse > 1) {
		// 	newFuse = 1;
		// }
		// scopeThis.$el.setAttribute("style", "--autoprogress:" + newFuse);
		// // requestAnimationFrame(scopeThis.timerTick);
		// setTimeout(function () {
		// 	scopeThis.timerTick();
		// }, 1);
	}
}
